import clsx from "clsx";
import type { ComponentType, SVGProps } from "react";

type Props = {
	icon: ComponentType<SVGProps<SVGSVGElement>>;
	label: string;
	value: string;
	hint?: string;
	valueClassName?: string;
};

export function FigureRow({ icon: Icon, label, value, hint, valueClassName = "text-gray-900" }: Props) {
	return (
		<div className="flex items-center gap-3 py-1.5">
			<span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white">
				<Icon aria-hidden className="size-4" />
			</span>
			{/* The page is `lang="en"`; the label is German, so the hyphenation needs `de`. */}
			<dt lang="de"
				className={clsx(
					"min-w-0 flex-1 hyphens-auto text-base font-semibold text-gray-700 lg:text-sm",
				)}>{label}</dt>
			<dd className={clsx("text-xl font-semibold lg:text-lg", valueClassName)}>
				{value}
				{hint && <span className="ml-2 text-xs font-normal text-gray-500">{hint}</span>}
			</dd>
		</div>
	);
}
